
import { supabase } from '@/integrations/supabase/client';

export type UserRole = 'admin' | 'moderator' | 'user';

export const checkUserRole = async (email: string, role: UserRole): Promise<boolean> => {
  try {
    const { data, error } = await supabase.rpc('has_role', {
      user_email: email,
      check_role: role
    });

    if (error) {
      console.error('Error checking user role:', error);
      return false;
    }

    return data || false;
  } catch (error) {
    console.error('Error checking user role:', error);
    return false;
  }
};

export const assignUserRole = async (email: string, role: UserRole, userId?: string): Promise<{ success: boolean; message: string }> => {
  try {
    const { error } = await supabase
      .from('user_roles')
      .insert({
        email,
        role,
        user_id: userId || ''
      });

    if (error) {
      console.error('Error assigning user role:', error);
      return { success: false, message: 'Failed to assign role' };
    }

    return { success: true, message: 'Role assigned successfully' };
  } catch (error) {
    console.error('Error assigning user role:', error);
    return { success: false, message: 'Failed to assign role' };
  }
};

export const removeUserRole = async (email: string, role: UserRole): Promise<{ success: boolean; message: string }> => {
  try {
    const { error } = await supabase
      .from('user_roles')
      .delete()
      .eq('email', email)
      .eq('role', role);

    if (error) {
      console.error('Error removing user role:', error);
      return { success: false, message: 'Failed to remove role' };
    }

    return { success: true, message: 'Role removed successfully' };
  } catch (error) {
    console.error('Error removing user role:', error);
    return { success: false, message: 'Failed to remove role' };
  }
};
